import axios from 'axios'
import { ElMessage } from 'element-plus'
import { globals } from '@/utils/globals'


// 创建axios实例但不立即设置baseURL
const service = axios.create({
  timeout: 10000
})


// 请求拦截器
service.interceptors.request.use(config => {
  const serverUrl=globals.$config?.serverUrl||'http://localhost:8080'
  config.baseURL=serverUrl
  
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
    // console.log("token:",token)
  }
  return config
})

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 直接返回响应数据
    return response.data
  },
  error => {
    if (error.response) {
      const { status, data } = error.response
      switch (status) {
        case 401:
          ElMessage.error('身份验证失败，请重新登录')
          break
        case 403:
          ElMessage.error('权限不足，无法执行此操作')
          break
        default:
          ElMessage.error(`请求错误: ${data?.msg || error.message}`)
      }
    } else {
      ElMessage.error('网络错误，请检查您的连接')
    }
    return Promise.reject(error)
  }
)

export default service






